// extracted by mini-css-extract-plugin
module.exports = {"select":"CustomSelectInput-module--select--220jJ"};